<app-file-uploader
  [label]="label"
  [description]="description"
  [accept]="accept"
  [scope]="scope"
  [bupload]="bupload"
  [fieldName]="fieldName"
  [queueLimit]="queueLimit"
  [ngModel]="ngModel"
  (ngModelChange)="ngModelChange.next($event)"
>
</app-file-uploader>
